import { extend } from '@/lib/utils/extend';
import Toast from "vant/es/toast";
import "vant/es/toast/style/index.js";
var AbpNotify = /** @class */ (function () {
    function AbpNotify() {
    }
    AbpNotify.success = function (message, title, options) {
        options = options || {};
        options.message = message;
        Toast.success(options);
    };
    AbpNotify.info = function (message, title, options) {
        options = options || {};
        options.message = message;
        Toast(options);
    };
    AbpNotify.warn = function (message, title, options) {
        options = options || {};
        options.message = message;
        Toast.fail(options);
    };
    AbpNotify.error = function (message, title, options) {
        options = options || {};
        options.message = message;
        options.type = 'error';
        Toast(options);
    };
    AbpNotify.fatal = function (message, title, options) {
        options = options || {};
        options.message = message;
        Toast.fail(options);
    };
    return AbpNotify;
}());
var abpNotify = {
    notify: AbpNotify
};
window.abp = extend(true, window.abp, abpNotify);
